import React from 'react';

// COMPONENT
import SvgMask from '../_Helpers/SvgMask';

// TYPE
export type QuestionState = 'default' | 'success' | 'danger';

interface GraphemeQuestionProps {
	id?: string;
	label: string;
	className?: string;
	state?: QuestionState;
	isSmallSize?: boolean;
	shouldHighlight?: boolean;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const GraphemeQuestion: React.FC<GraphemeQuestionProps> = ({
	id,
	label,
	state = 'default',
	className = '',
	onClick,
	isSmallSize,
	shouldHighlight
}) => {
	return (
		<div className={`${shouldHighlight ? 'highlight-outline rounded-3' : ''}`}>
			<button
				id={id}
				className={`grapheme-question ${className} ${state} ${isSmallSize ? 'small-size' : ''}`}
				onClick={onClick}
			>
				{label}

				{state === 'success' && (
					<div className="status-icon-wrapper">
						<SvgMask
							className="status-icon"
							path={'/svg/tick-success.svg'}
							width={isSmallSize ? 12 : 24}
							height={isSmallSize ? 12 : 24}
						/>
					</div>
				)}

				{state === 'danger' && (
					<div className="status-icon-wrapper">
						<SvgMask
							className="status-icon"
							path={'/svg/tick-danger.svg'}
							width={isSmallSize ? 12 : 24}
							height={isSmallSize ? 12 : 24}
						/>
					</div>
				)}
			</button>
		</div>
	);
};

export default GraphemeQuestion;
